import { OptionInterface } from "./interfaces";
import { SelectOption } from "./types"

export type tableColumnsCustom = 'idCustomCircuit' | 'nameCustomCircuit' | 'codeCustomCircuit' |
  'typeCustomCircuit' | 'dateCreateCustomCircuit' | 'authorCustomCircuit' | 'activeCustomCircuit';

export type tableColumnsCustomPanel = 'idCustomCircuit' | 'nameCustomCircuit' | 'codeCustomCircuit' | 'typeCustomCircuit' |
 'dateCreateCustomCircuit' | 'empresa' | 'activeCustomCircuit';

export type tableColumnsAreas = 'idArea' | 'nameArea' | 'externalId' | 'dateReg' | 'numCargos' | 'numUsers' | 'active';

export type tableColumnsInvitations = 'email' | 'guidInvitation' | 'invitationDate' | 'idUserRegistered' | 'idUserSender';

export type tableColumnsPositions = 'idCargo' | 'nameCargo' | 'nameArea' | 'numOrganizationUsers' | 'active';

export type tableColumnsUsers = 'idUser' | 'name' | 'username' | 'email' | 'phone' | 'userIvSign' |
  'dateReg' | 'idPerfil' | 'numAreas' | 'numCargos' | 'dateLastVisit' | 'active';

export type tableColumnsOrganizations = 'idCircuit' | 'titleCircuit' | 'externalIdCircuit' | 'destinatario' | 'nameCreator' |
  'nameArea' | 'orden' | 'operacion' | 'dateAccess' | 'dateClose' | 'firtsAccess' | 'estado';


export type tableColumnsOrganizationsPanel = 'id' | 'nombre' | 'orgaid' | 'cif' | 'fechaCreacion' | 'nEmpleados';

export type tableColumnsAdminCircuits = 'id' | 'circuitTypeName' | 'circuitName' | 'createDate' | 'idOrg' |
  'nombreOrg' | 'titleState' | 'credits' | 'externalIdCircuit' | 'creator';

export type tableColumnsManageCircuts = 'idAplicacion' | 'nombre' | 'activo' | 'sistema' | 'personalizaciones';

export type tableColumnsCustomization = 'appId' | 'url' | 'active';

export type tableColumnsCustomizationPanel = 'appId' | 'url' | 'repositorio' | 'custodia';

export type tableColumnsPanelCircuits = 'idAplicacion' | 'nombre' | 'sistema' | 'personalizaciones' | 'activo';

export type tableColumnsCredits = 'id' | 'nameOperation' | 'nameTypeCircuit' | 'credits';

export type tableColumnsDelegations = 'idDelegation' | 'nameDelegateType' | 'nameCreator' | 'circuitName' | 'nameDelegateTo'|
  'dateEnable' | 'dateDisable' | 'active';

export type tableColumnsCompany = 'id' | 'nameOrgParent' | 'nameOrgChild' | 'description' | 'dateReg';

export type tableColumnsDetail = 'evidenceName' | 'orderOperation' | 'receiver' | 'dateReg';

export type tableColumnsCircuitsOrga = 'id' | 'circuitTitle' | 'externalId' | 'nameCreator' | 'nameArea' | 'nameAreaParent' |
  'createDate' | 'circuitTypeName' | 'closeDate' | 'stateTitle';

export type tableColumnsCircuitsSent = 'id' | 'circuitTitle' | 'externalId' | 'nameCreator' | 'nameArea' | 'nameAreaParent' |
  'createDate' | 'circuitTypeName' | 'closeDate' | 'circuitTotalCredits' | 'stateTitle';

export type tableColumnsPending = 'idCircuit' | 'titleCircuit' | 'externalIdCircuit' | 'operacion' | 'nameCreator' | 'nameArea' |
  'nameAreaParent' | 'dateAccess' | 'estado';

export type tableColumnsAccessManager = 'idAccess' | 'appId' | 'orgaName';

export type tableColumnsPrefixes = 'id' | 'label' | 'value' | 'country' | 'regex';

export type tableColumnsTemplates = 'id' | 'tipo' | 'appId' | 'idEmpresa' | 'fDisponible' | 'descripcion' | 'tipoCircuito' | 'tipoOperacion';

export type tableColumnsUsersPanel = 'id' | 'name' | 'username' | 'idProfile' | 'email' | 'phone' | 'enabled' | 'userIvSign' | 'registrationDate' | 'organizationName';

export type tableColumnsAux = 'idOperation' | 'idCircuit' | 'parentId' | 'visible' | '';

export type columnsDetail = {
  key?: string,
  type: string,
  sort?: boolean,
  sortable?: boolean,
  header?: string,
  filter?: string,
  filterKey?: string,
  edit?: boolean,
  toggle?: boolean,
  hidden?: boolean,
  hiddencsv?: boolean,
  filterDropdown?: SelectOption[],
  width?: string,
  filterType?: string,
  formatDate?: string,
  formatDateFilter?: string,
  formatDateHeader?: string,
  attr?: attributeDetail,
  cellClass?: unknown,
  idCompany?: columnsDetail,
  delegateType?: columnsDetail,
  delegateTo?: columnsDetail,
  changeValue?: string[],
  filterDisabled?: boolean,
  resizableColumns?: boolean,
  value?: boolean
}

export type attributeDetail = {
  options: optionsDetail
}

export type optionsDetail = {
  dateRange: boolean,
  dateFormat: string,
  locale: string
}

export type filterDetail = {
  label: string,
  name: string,
  filterString: string,
  filterOdata: string,
  filterMatchMode: string,
  formatDate: string,
  type: string,
  filterKey?: string,
  filterDate?: Date[],
  itemsSelected?: string[],
  searchBefore?: boolean,
  disabled?: boolean;
  attr?: attributeDetail,
  selectOptions?: OptionInterface[],
  value?: string
}

export type filterSent = {
  key: string,
  value: unknown,
  type: string
}

export type gridSettings = {
  selectionMode: string;
  value: any[];
  filter?: string;
  rows: number;
  paginator: boolean;
  pageLinks: number;
  responsive: boolean;
  reflowVar?: number;
  nofixed?: boolean;
  reorderableColumns: boolean;
  paginatorControl: boolean;
  leftInitial?: number;
  editable: boolean;
  emptyMessage?: string;
  lazy: boolean;
  resizableColumns: boolean;
  exportCsv: boolean;
  nameButtonCsv?: string;
  widthDialogCSV?: number;
  exportHeadFix: boolean;
  exportCsvName: string;
  advancedSearch: boolean;
  actions?: boolean;
  showCaption?: boolean;
  titleCaption?: string;
  classCaption?: string;
  showHeader?: boolean;
  classHeader?: string;
  classHeaderFilter?: string;
  showBody?: boolean;
  showSummary?: boolean;
  titleSummary?: string;
  showFooter?: boolean;
  orderBy?: string;
  classBodyTD?: string;
  rowExpansionDivLvl1?: string;
  rowExpansionDivLvl2?: string;
  showExpanded?: boolean;
  keyMainTable?: string;
  showContextMenuClass?: string;
  Orden?: number;
  select?: boolean;
  disabled?: boolean;
  icon?: string;
}

export type dataTable = {
  count: number,
  Count: number,
  Items: unknown[];
  items: unknown[];
}

export type DataAreas = {
  UserRole: unknown[],
  active: string,
  cargoList: unknown[],
  children: DataAreas,
  dateDel: string,
  dateReg: string,
  externalid: unknown,
  idArea: number,
  idCompany: number,
  isOpen: boolean,
  nameArea: string,
  nameCompany: string,
  nameParent: string,
  numCargos: number,
  numUsers: number,
  parentId: number,
  hidden: boolean
}


export type typeColumns = tableColumnsCustom | tableColumnsAreas | tableColumnsInvitations | tableColumnsPositions | tableColumnsUsers | tableColumnsOrganizations |
tableColumnsAdminCircuits | tableColumnsManageCircuts | tableColumnsPanelCircuits | tableColumnsCredits | tableColumnsDelegations | tableColumnsCompany |
tableColumnsDetail | tableColumnsCircuitsOrga | tableColumnsCircuitsSent | tableColumnsPending | tableColumnsAccessManager | tableColumnsAux;


export type TableSettings = {
  selectionMode: string;
  value: unknown[];
  filter?: string;
  rows: number;
  paginator: boolean;
  pageLinks: number;
  responsive: boolean;
  reflowVar?: number;
  nofixed?: boolean;
  reorderableColumns: boolean;
  paginatorControl: boolean;
  leftInitial?: number;
  editable: boolean;
  emptyMessage?: string;
  lazy: boolean;
  resizableColumns: boolean;
  exportCsv: boolean;
  nameButtonCsv?: string;
  widthDialogCSV?: number;
  exportHeadFix: boolean;
  exportCsvName: string;
  advancedSearch: boolean;
  actions?: boolean;
  showCaption?: boolean;
  titleCaption?: string;
  classCaption?: string;
  showHeader?: boolean;
  classHeader?: string;
  classHeaderFilter?: string;
  showBody?: boolean;
  showSummary?: boolean;
  titleSummary?: string;
  showFooter?: boolean;
  orderBy?: string;
  classBodyTD?: string;
  rowExpansionDivLvl1?: string;
  rowExpansionDivLvl2?: string;
  showExpanded?: boolean;
  keyMainTable?: string;
  showContextMenuClass?: string;
  Orden?: number;
  select?: boolean;
  disabled?: boolean;
  icon?: string;
}

export type ConfigSettings = {
  type: number;
  url: string;
  endPoint: string;
  auth: string;
  idElemScroll?: string;
  isModal?: boolean;
}

export enum ConfigEnum {
  rest = 1,
  apiweb = 2
}

export enum FilterTypeEnum {
  BOOLEAN = 'boolean',
  DATE = 'date',
  NUMBER = 'int',
  SELECT = 'select',
  TEXT = 'text',
  AUX = 'aux'
}

export type ToolbarConfig = {
  icon: string;
  label: string;
  onClick?: string;
  disabledbutton?: boolean;
  name: string;
  hidden?: boolean;
}
